import React from 'react';

import Layout from '../components/Layout';
import Scroll from '../components/Scroll';

import config from '../../config';
import Footer from '../components/Footer';
import Header from '../components/Header';
import ScrollToTop from '../components/ScrollToTop';


import p10 from '../assets/images/eshop4.gif';
import p11 from '../assets/images/eshop5.gif';
import p12 from '../assets/images/eshop3.gif';
import p13 from '../assets/images/eshop2.gif';


const IndexPage = () => (
  <Layout>
    <Header />

    <div className="col-lg-6">
            <a className="portfolio-item" href="#">
              <span className="caption">
                <span className="caption-content">
                  <h2></h2>
                  <p className="mb-0">
                  <b> Shop Online with just a click...</b>
                  </p>
                </span>
              </span>
              <img className="img-fluid" src={p10} alt="" />
            </a>


          </div>

   

    


    

    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://amazon.com/" className="btn btn-xl btn-light mr-4">
         Amazon
        </a>
        <a href="http://aliexpress.com/" className="btn btn-xl btn-dark">
         AliExpress
        </a>
      </div>
    </section>




 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://ebay.com/" className="btn btn-xl btn-light mr-4">
         Ebay
        </a>
        <a href="https://www.target.com/" className="btn btn-xl btn-dark">
          Target
        </a>
      </div>
    </section>



  <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.walmart.com/?sourceid=imp_3VBQhtRT2xyLUAAwUx0Mo3EJUkEXPXxS1S96Uw0&veh=aff&wmlspartner=imp_143303&clickid=3VBQhtRT2xyLUAAwUx0Mo3EJUkEXPXxS1S96Uw0&sharedid=&affiliates_ad_id=565706&campaign_id=9383&irgwc=1&sourceid=imp_3VBQhtRT2xyLUAAwUx0Mo3EJUkEXPXxS1S96Uw0&veh=aff&wmlspartner=imp_143303&clickid=3VBQhtRT2xyLUAAwUx0Mo3EJUkEXPXxS1S96Uw0&sharedid=&affiliates_ad_id=565706&campaign_id=9383" className="btn btn-xl btn-light mr-4">
          Walmart
        </a>
        <a href="https://www.ikea.com/" className="btn btn-xl btn-dark">
         Ikea
        </a>
      </div>
    </section>







      <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.groupon.com/" className="btn btn-xl btn-light mr-4">
          Groupon
        </a>
        <a href="https://jumia.com/" className="btn btn-xl btn-dark">
          Jumia
        </a>
      </div>
    </section>




     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://wayfair.com/" className="btn btn-xl btn-light mr-4">
          Wayfair
        </a>
        <a href="https://jumia.com/" className="btn btn-xl btn-dark">
          Jumia
        </a>
      </div>
    </section>




 <section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>
          <img className="img-fluid" src={p11} alt="" />
          <h2 className="mb-5"> Do your Online Shopping on the Internet Smartly..<i className="fa fa-shopping-cart fa-spin"></i></h2>
        </div>
        
      </div>
    </section>

   



 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.wish.com/" className="btn btn-xl btn-light mr-4">
         Wish
        </a>
        <a href="https://www.alibaba.com/?__redirected__=1" className="btn btn-xl btn-dark">
        Alibaba
        </a>
      </div>
    </section>





     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://melcomonline.com/" className="btn btn-xl btn-light mr-4">
         Melcom
        </a>
        <a href="http://superprice.com/" className="btn btn-xl btn-dark">
        Superprice
        </a>
      </div>
    </section>






     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://zoobashop.com/" className="btn btn-xl btn-light mr-4">
         Zoobashop
        </a>
        <a href="https://www.kikuu.com/" className="btn btn-xl btn-dark">
          Kikuu Online Shop
        </a>
      </div>
    </section>



<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.shopify.com/" className="btn btn-xl btn-light mr-4">
        Shopify
        </a>
        <a href="https://www.ae.com/intl/en" className="btn btn-xl btn-dark">
         American eagle
        </a>
      </div>
    </section>


<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.forever21.com/" className="btn btn-xl btn-light mr-4">
        Forever21
        </a>
        <a href="https://shop.lululemon.com/" className="btn btn-xl btn-dark">
          Lululemon
        </a>
      </div>
    </section>



 <section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>
          <img className="img-fluid" src={p12} alt="" />
          <h2 className="mb-5"> Do your Online Shopping on the Internet Smartly..<i className="fa fa-shopping-cart fa-spin"></i></h2>
        </div>
        
      </div>
    </section>



<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.overstock.com/" className="btn btn-xl btn-light mr-4">
       Overstock
        </a>
        <a href="https://www.inspireuplift.com/" className="btn btn-xl btn-dark">
          Inspire Uplift
        </a>
      </div>
    </section>


    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.adidas.ca/en?utm_medium=best-websites&utm_source=oberlo.com" className="btn btn-xl btn-light mr-4">
       Adidas
        </a>
        <a href="https://colourpop.com/?utm_source=oberlo.com&utm_medium=best-websites" className="btn btn-xl btn-dark">
          Colour POP
        </a>
      </div>
    </section>


    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.chubbiesshorts.com/?utm_source=oberlo.com&utm_medium=best-websites" className="btn btn-xl btn-light mr-4">
        Chubbie Shorts
        </a>
        <a href="https://www.mvmt.com/home?utm_medium=best-websites&utm_source=oberlo.com" className="btn btn-xl btn-dark">
          MVMT
        </a>
      </div>
    </section>


    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://ca.gymshark.com/?utm_source=oberlo.com&utm_medium=best-websites" className="btn btn-xl btn-light mr-4">
        GYMSHARK
        </a>
        <a href="https://urban-planet.com/pages/sirens?utm_source=oberlo.com&utm_medium=best-websites" className="btn btn-xl btn-dark">
          Urban-Planet
        </a>
      </div>
    </section>


    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://blnts.com/?utm_source=oberlo.com&utm_medium=best-websites" className="btn btn-xl btn-light mr-4">
        Blue Note
        </a>
        <a href="https://suzyshier.com/?utm_source=oberlo.com&utm_medium=best-websites" className="btn btn-xl btn-dark">
         SuzyShier
        </a>
      </div>
    </section>






<section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>
          <img className="img-fluid" src={p13} alt="" />
          <h2 className="mb-5"> Do your Online Shopping on the Internet Smartly..<i className="fa fa-shopping-cart fa-spin"></i></h2>
        </div>
        
      </div>
    </section>



<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.puravidabracelets.com/?utm_source=oberlo.com&utm_medium=best-websites" className="btn btn-xl btn-light mr-4">
       Puravida Bracelets
        </a>
        <a href="https://fanjoy.co/?utm_source=oberlo.com&utm_medium=best-websites" className="btn btn-xl btn-dark">
          Fanjoy
        </a>
      </div>
    </section>





<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.velourbeauty.com/?utm_source=oberlo.com&utm_medium=best-websites" className="btn btn-xl btn-light mr-4">
       Velour Beauty
        </a>
        <a href="https://www.youngandreckless.com/?utm_source=oberlo.com&utm_medium=best-websites" className="btn btn-xl btn-dark">
          Y&R
        </a>
      </div>
    </section>




<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.rriveter.com/?utm_source=oberlo.com&utm_medium=best-websites" className="btn btn-xl btn-light mr-4">
       R Riveter
        </a>
        <a href="https://johnscrazysocks.com/?utm_source=oberlo.com&utm_medium=best-websites" className="btn btn-xl btn-dark">
         John'S crazy Socks
        </a>
      </div>
    </section>



<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.prettylittlething.us/?utm_source=oberlo.com&utm_medium=best-websites" className="btn btn-xl btn-light mr-4">
       Pretty Little Thing
        </a>
        <a href="https://www.kyliecosmetics.com/?utm_source=oberlo.com&utm_medium=best-websites" className="btn btn-xl btn-dark">
          Kylie Cosmetics
        </a>
      </div>
    </section>


<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://teasetea.com/?utm_source=oberlo.com&utm_medium=best-websites" className="btn btn-xl btn-light mr-4">
       Tease Tea
        </a>
        <a href="https://www.flipkart.com/" className="btn btn-xl btn-dark">
         Flipkart
        </a>
      </div>
    </section>





    {/* <section id="contact" className="map">
      <iframe
        width="100%"
        height="100%"
        frameborder="0"
        scrolling="no"
        marginheight="0"
        marginwidth="0"
        src="https://maps.google.com/maps?f=q&amp;source=s_q&amp;hl=en&amp;geocode=&amp;q=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;aq=0&amp;oq=twitter&amp;sll=28.659344,-81.187888&amp;sspn=0.128789,0.264187&amp;ie=UTF8&amp;hq=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;t=m&amp;z=15&amp;iwloc=A&amp;output=embed"
      ></iframe>
      <br />
      <small>
        <a href="https://maps.google.com/maps?f=q&amp;source=embed&amp;hl=en&amp;geocode=&amp;q=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;aq=0&amp;oq=twitter&amp;sll=28.659344,-81.187888&amp;sspn=0.128789,0.264187&amp;ie=UTF8&amp;hq=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;t=m&amp;z=15&amp;iwloc=A"></a>
      </small>
    </section> */}

    <ScrollToTop />
    <Footer />
  </Layout>
);

export default IndexPage;
